var SENTRY_RELEASE;SENTRY_RELEASE={name: "next-app", version: "6.1.5"};